import React from 'react';
import dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import {useTranslation} from 'react-i18next';
import {useSummary} from 'context/summary';

import {
  BookingInfoContainer,
  BookingInfoItem,
  BookingInfoText,
  BookingInfoTitle,
} from './styled';

const getFormatedDate = (date = '', format: string) => {
  return dayjs(date).utc().format(format);
};

function HomeBookingStatusPanel() {
  const {data} = useSummary();
  // const {data: reservation} = useReservation();
  dayjs.extend(utc.default);
  const check_in_date = data?.check_in_date;
  const check_out_date = data?.check_out_date;
  const expected_guests = data?.expected_guests;
  const monthDateFormat = 'MMM';
  const checkInFormattedDate = getFormatedDate(
    check_in_date,
    `D ${monthDateFormat} YYYY`,
  );
  const checkOutFormattedDate = getFormatedDate(
    check_out_date,
    `D ${monthDateFormat} YYYY`,
  );
  const {t} = useTranslation();

  // const {
  //   isOpen: isOpenConfirmModal,
  //   closeModal: closeConfirmModal,
  //   openModal: openConfirmModal,
  // } = useModalControls();
  // const yearsAbove = data?.booking?.age_group.find(
  //   (ag: AgeGroup) => ag?.name === AGE_USER_TYPE.adult,
  // );

  // const {openModal} = useModalOncePerSession({
  //   id: reservation?.id,
  //   storageKey: SHOWED_GUEST_GROUP_MODAL,
  // });

  // React.useEffect(() => {
  //   const isProcessComplete =
  //     data?.guest_registration?.status === NAVIGATION_STATUSES.completed;
  //   if (openModal && !isProcessComplete) openConfirmModal();
  // }, [openModal, openConfirmModal, data?.guest_registration?.status]);

  return (
    <BookingInfoContainer>
      <BookingInfoItem width="35%">
        <BookingInfoTitle>{t('check_in_short')}</BookingInfoTitle>
        <BookingInfoText capitalize>{checkInFormattedDate}</BookingInfoText>
        {/*<BookingInfoText secondary>14:00 H</BookingInfoText>*/}
      </BookingInfoItem>

      <BookingInfoItem width="35%">
        <BookingInfoTitle>{t('check_out_short')}</BookingInfoTitle>
        <BookingInfoText capitalize>{checkOutFormattedDate}</BookingInfoText>
        {/*<BookingInfoText secondary>10:00 H</BookingInfoText>*/}
      </BookingInfoItem>

      <BookingInfoItem width="20%">
        <BookingInfoTitle>{t('guests')}</BookingInfoTitle>
        <BookingInfoText>{expected_guests}</BookingInfoText>
      </BookingInfoItem>
    </BookingInfoContainer>
  );
}
// HomeBookingStatusPanel.defaultProps = defaultProps;

export {HomeBookingStatusPanel};
